import { memo } from 'react';
import { InnerButton } from '@/modules/InnerButton';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

interface AccordionHeaderProps {
  title: string;
  subtitle?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  id?: string;
  ariaControls?: string;
}

export const AccordionHeader = memo(
  ({
    title,
    subtitle,
    open,
    setOpen,
    className = '',
    children,
    disabled = false,
    id,
    ariaControls,
  }: AccordionHeaderProps) => {
    // Validación mejorada de children: 0 es válido en React pero falsy en JavaScript
    const hasContent = children !== null && children !== undefined && children !== false;
    const isDisabled = !hasContent || disabled;

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!isDisabled) {
          setOpen(!open);
        }
      }
    };

    return (
      <div
        id={id}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        aria-expanded={open}
        aria-controls={ariaControls}
        className={`ui-box-border ui-flex ui-w-full ui-items-center ui-gap-0 ui-p-0 ${className}`}
      >
        <div className="ui-flex ui-flex-1 ui-flex-col ui-items-start ui-gap-0">
          <p
            className={`ui-m-0 ui-whitespace-pre-wrap ui-text-label-md-bold ui-font-label-md-bold ui-leading-label-md-bold ui-tracking-label-md ${isDisabled ? 'ui-text-disabled' : 'ui-text-primary'}`}
          >
            {title}
          </p>
          {subtitle && (
            <p
              className={`ui-tracking-body-xs-regular ui-m-0 ui-whitespace-pre-wrap ui-text-body-xs-regular ui-font-body-xs-regular ui-leading-body-xs-regular ${isDisabled ? 'ui-text-disabled' : 'ui-text-secondary'}`}
            >
              {subtitle}
            </p>
          )}
        </div>

        <div className="ui-box-border ui-flex ui-items-center ui-justify-center">
          <InnerButton
            theme="solid"
            size="xs"
            disabled={isDisabled}
            color="tertiary"
            pill="pill"
            onClick={() => setOpen(!open)}
            icon={open ? faChevronUp : faChevronDown}
            tooltipProps={{
              label: open ? 'Cerrar' : 'Abrir',
            }}
          />
        </div>
      </div>
    );
  }
);

AccordionHeader.displayName = 'AccordionHeader';
